export default __webpack_public_path__ + "static/media/next.9e3a58b4.svg";